<template>
  <section class="account-next-steps">
    <h1 class="account-next-steps__title title" v-if="title">
      <VisibleText>Finish setting up your account</VisibleText>
      <small class="text-muted">{{ title }}</small>
    </h1>
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'accountNextSteps',
  data() {
    return {
      titles: {
        accountNextStepsProfile: 'Profile',
      },
    };
  },
  created() {},
  computed: {
    title: function () {
      return this.titles[this.$route.name] || null;
    },
  },
};
</script>
